import { PeopleRelatedRole } from 'src/features/CompanyDetail/Common/config';

export const getPeopleRelatedRoleLabel = (type: PeopleRelatedRole) => {
  switch (type) {
    case PeopleRelatedRole.Chairman:
      return 'Chairman';
    case PeopleRelatedRole.ChiefExecutiveOfficer:
      return 'Chief Executive Officer';
    case PeopleRelatedRole.Director:
      return 'Director';
    case PeopleRelatedRole.ExportPromotionAgency:
      return 'Export Promotion Agency';
    case PeopleRelatedRole.Manager:
      return 'Manager';
    case PeopleRelatedRole.TeamLeader:
      return 'Team Leader';
    case PeopleRelatedRole.TeamMember:
      return 'Team Member';
    default:
      return type;
  }
};
